import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChange,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { ISystemNotificationTab } from '@fi-app/system-notifications/system-notifications.service';

@Component({
    selector: 'fi-system-notifications-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-system-notifications-tabs' },
    standalone: false,
})
export class SystemNotificationsTabsComponent implements OnChanges {
    @Output() selectedTabChange = new EventEmitter<ISystemNotificationTab>();
    @Input() tabs: ISystemNotificationTab[];

    protected selectedTabIndex: number = -1;
    private _selectedTab: ISystemNotificationTab;

    protected isTabSelected(tabId: string) {
        return tabId === this._selectedTab?.id;
    }

    protected selectIndex($event: number): void {
        this.selectedTabIndex = $event;
        this._selectedTab = $event >= 0 ? this.tabs[$event] : undefined;
        this.selectedTabChange.emit(this._selectedTab);
    }

    protected swipeLeft(): void {
        if (this.selectedTabIndex > 0) {
            this.selectIndex(this.selectedTabIndex - 1);
        }
    }

    protected swipeRight(): void {
        if (this.selectedTabIndex < this.tabs.length - 1) {
            this.selectIndex(this.selectedTabIndex + 1);
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.tabs) {
            this._handleTabsChange(changes.tabs);
        }
    }

    private isDeviationsTabFound = false;
    private isChecklistsTabFound = false;
    private _handleTabsChange(change: SimpleChange): void {
        // logic for proper tabs update
        // https://chainformation.atlassian.net/browse/FI-1675
        // https://chainformation.atlassian.net/browse/FI-2895
        const curentTabs: ISystemNotificationTab[] = change.currentValue;
        if (!curentTabs.length) {
            this.selectIndex(-1);
            return;
        }
        if (!this._selectedTab) {
            this.selectIndex(0);
        }

        const currentTabIndex = curentTabs.indexOf(this._selectedTab);
        this.selectedTabIndex = currentTabIndex;
        if (currentTabIndex === -1) {
            this.selectIndex(-1);
            setTimeout(() => this.selectIndex(0));
        }

        if (!this.isDeviationsTabFound) {
            let tabIndex = checkAutoSelectTab(curentTabs, 'deviations');
            if (tabIndex !== -1) {
                this.isDeviationsTabFound = true;
                setTimeout(() => this.selectIndex(tabIndex));
                return;
            }

            if (!this.isChecklistsTabFound) {
                tabIndex = checkAutoSelectTab(curentTabs, 'checklists');
                if (tabIndex !== -1) {
                    this.isChecklistsTabFound = true;
                    setTimeout(() => this.selectIndex(tabIndex));
                    return;
                }
            }
        }
    }
}

function checkAutoSelectTab(newVal: ISystemNotificationTab[], tabName: string): number {
    return newVal.map((item) => item.id).indexOf(tabName);
}
